import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'dp-badge-name',
  templateUrl: './dp-badge-name.component.html',
  styleUrls: ['./dp-badge-name.component.scss']
})
export class DpBadgeNameComponent implements OnInit {

  _name;
  @Input()
  cssClass;

  constructor() {
  }

  _code;

  @Input()
  set code(value: string) {
    this._code = value;
    this.returnName();
  }

  _options;

  @Input()
  set options(value: any[]) {
    this._options = value;
    this.returnName();
  }

  returnName() {
    if (!this._code || !this._options?.length) {
      return;
    }
    const filterOptions = this._options.filter(f => f.code === this._code);
    this._name = filterOptions.length ? filterOptions[0].name : '';
  }

  ngOnInit() {
  }

}
